export interface RecaptchaRequest<T> {
  token: string;
  data: T;
}
